import { foundation } from './tokens';

export const interactiveBase = {
  cursor: 'pointer',
  transition: 'background-color 150ms ease, border-color 150ms ease, color 150ms ease, box-shadow 150ms ease, opacity 150ms ease',
  WebkitTapHighlightColor: 'transparent',
};
export const disabledState = { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' };
export const hoverSurface = { backgroundColor: foundation.color.neutral.surfaceMuted };
export const hoverPrimary = { backgroundColor: foundation.color.brand.primaryHover || foundation.color.brand.primary, boxShadow: foundation.shadow.sm };
export const focusRing = { outline: 'none', boxShadow: `0 0 0 2px ${foundation.color.brand.primaryMuted}` };
